import AccountService from "./account/accountService";
import AssetService from "./asset/assetService";
import MerchantService from "./merchant/merchantService";
import NotificationService from "./notification/notificationService";
import UnitService from "./unit/unitService";
import AuthenService from "./user/authenService";
import UserService from "./user/userService";

export default {
  AuthenService,
  UserService,
  AssetService,
  UnitService,
  AccountService,
  MerchantService,
  NotificationService,
};
